module.exports = __webpack_public_path__ + "img/Image 12.4b60f54a.png";